import { render, staticRenderFns } from "./PedidoDeCompraEnviarPedidoView.vue?vue&type=template&id=6b3e6868&scoped=true"
import script from "./PedidoDeCompraEnviarPedidoView.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoDeCompraEnviarPedidoView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PedidoDeCompraEnviarPedidoView.vue?vue&type=style&index=0&id=6b3e6868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e6868",
  null
  
)

export default component.exports